import i18n, { ModuleType } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enMessages from './local/en/common';
import zhMessages from './local/zh/common';

const messages = {
  en: { translation: enMessages },
  zh: { translation: zhMessages },
};

// 获取存储的语言或默认中文
const getSavedLanguage = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('i18nextLng') || 'zh';
  }
  return 'zh';
};

// Initialize i18n with promise
const initPromise = i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: getSavedLanguage(),
    fallbackLng: 'zh',
    debug: process.env.NODE_ENV === 'development',
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

// 监听语言变化并保存到 localStorage
i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('i18nextLng', lng);
    document.documentElement.lang = lng;
  }
});

// Export the initialization promise so we can await it
export { initPromise };

export default i18n;
